import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import { EffectFade, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

const Info2Carousel = ({ info1Data }) => {
  const swiperRef = useRef(null)
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0)

  return (
    <Wrapper>
      <div className="amenities">
        {info1Data?.block?.map((headline, index) => (
          <div
            onClick={() => {
              setCurrentInfoIndex(index), swiperRef.current.slideTo(index)
            }}
            className={index === currentInfoIndex ? "active" : ""}
          >
            {headline.headline}
          </div>
        ))}
      </div>

      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        effect="fade"
        className="bgImage"
        spaceBetween={0}
        slidesPerView={1}
        centeredSlides={true}
        onSlideChange={(_swiper) => setCurrentInfoIndex(_swiper.activeIndex)}
        fadeEffect={{ crossFade: true }}
        modules={[EffectFade]}
        speed={400}
      >
        {info1Data?.block.map((content, index) => (
          <SwiperSlide
            key={content?.img?.publicURL + index?.toString()}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: index === 0 ? "contain" : "cover",
                padding: index === 0 ? "6rem" : "0",
              }}
              alt={content?.content?.filename}
              src={content?.img?.publicURL}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <Title>
        <div className="mainText">
          <div className="headline">
            {info1Data?.block[currentInfoIndex]?.headline &&
              (() => {
                const [firstWord, ...rest] =
                  info1Data.block[currentInfoIndex].headline.split(" ")
                return (
                  <>
                    <span>
                      {firstWord} <br />{" "}
                    </span>
                    <span
                      style={{
                        fontFamily: "SecondaryFont",
                        textTransform: "lowercase",
                        color: "var(--accent)",
                      }}
                    >
                      {rest.join(" ")}
                    </span>
                  </>
                )
              })()}
          </div>
        </div>
      </Title>

      <div className="bottomBar">
        <div className="controls">
          <div className="button">
            <div
              onClick={() => {
                if (currentInfoIndex - 1 !== -1) {
                  setCurrentInfoIndex(currentInfoIndex - 1)
                  swiperRef.current.slideTo(currentInfoIndex - 1)
                } else {
                  setCurrentInfoIndex(info1Data?.block?.length - 1)
                  swiperRef.current.slideTo(info1Data?.block.length - 1)
                }
              }}
            >
              <img src="/assets/icons/back.svg" alt="" />
            </div>
            <div
              onClick={() => {
                if (currentInfoIndex + 1 !== info1Data?.block?.length) {
                  setCurrentInfoIndex(currentInfoIndex + 1)
                  swiperRef.current.slideTo(currentInfoIndex + 1)
                } else {
                  setCurrentInfoIndex(0)
                  swiperRef.current.slideTo(0)
                }
              }}
            >
              <img
                src="/assets/icons/back.svg"
                style={{ transform: "rotate(180deg)" }}
                alt=""
              />
            </div>
          </div>
          {/* <div className="copy">
            
              
            </div>
          </div> */}
        </div>
      </div>
    </Wrapper>
  )
}

export default Info2Carousel

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .bgImage {
    position: relative;
    width: 87%;
    height: 100%;
    z-index: 0;
  }

  .copy {
    visibility: hidden;
    width: 100%;
    margin-right: auto;
    height: 85%;
    padding: 2rem;
    display: flex;
    align-items: center;
    color: var(--black);
    z-index: 1;
    pointer-events: none;

    .mainText {
      width: 100%;
      display: flex;
      justify-content: end;
      gap: 4rem;
      align-items: center;
      text-align: left;

      .headline {
        /* width: 20%; */
        font-size: 2rem;
        color: white;
        padding-right: 4rem;
        /* border-right: solid 1px var(--accent); */
      }

      .body {
        /* width: 75%; */
        height: 100%;
        font-size: 0.85rem;
        line-height: 150%;
        color: var(--black);
      }
    }
  }

  .bottomBar {
    position: absolute;
    bottom: 0;
    display: flex;
    margin-left: auto;
    margin-top: auto;
    width: 83%;
    height: 15%;
    /* box-shadow: inset 0 -200px 100px 10px rgba(0, 0, 0, 0.5); */
    /* background-color: var(--primary); */
    z-index: 1;
    padding: 0 2rem;
    /* border-top: 1px solid var(--accent); */
  }

  .controls {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5rem;
    z-index: 1;

    .button {
      position: fixed;
      left: 0;
      margin: 5rem;
      display: flex;
      gap: 1rem;
      cursor: pointer;

      div {
        border: 1px solid white;
        background-color: var(--secondary);
        padding: 1rem;
        color: #fff;
        width: 4rem;
        height: 4rem;
        border-radius: 5px;
        img {
          width: 100%;
          height: 100%;
          padding: 0.5rem;
          filter: invert(100%);
        }
        &:active {
          opacity: 0.75;
          transform: scale(0.95);
          transition: 0.3s;
        }
      }
    }
  }

  .index {
    margin: auto 0;
    margin-left: auto;
    font-size: 2rem;
    color: white;
    letter-spacing: 5px;
  }

  .amenities {
    width: 17%;
    position: relative;
    background-color: var(--secondary);
    border-right: 1px solid var(--accent);
    border-left: 1px solid var(--accent);
    font-family: SecondaryFont;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    color: #00000068;
    justify-content: center;
    padding: 3rem;
    gap: 3rem;
    transition: 0.3s;
    cursor: pointer;
    height: 100%;
    font-size: 1.15rem;
    white-space: nowrap;
    color: var(--primary);
    .active {
      color: var(--accent);
      transition: 0.3s;
    }
  }
`

const Title = styled.div`
  position: absolute;
  top: 0%;
  right: 0%;
  width: 100%;
  text-align: right;
  padding: 2rem 2rem;
  font-size: 4rem;
  line-height: 3rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask: linear-gradient(to left, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 0) 40%);
`
